import type { PropsWithChildren } from "react";
import { useIsFocused } from "@-/com.npmjs.expo-router/react-navigation";
import { LearnLayoutContext } from "#learn-layout-context";
import { useLearnLayoutContextValue } from "#learn-layout-context-value";
import { VoiceStudyProvider } from "@-/dev.improve.haniverse.lib.voice-study";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useIsLearnMapOpen } from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.map-mode";

export function LearnLayoutContextProvider({ children }: PropsWithChildren) {
  const value = useLearnLayoutContextValue();
  const [muted, setMuted] = useContextSelectors(
    NavContext,
    (c) => c.isMutedOverride,
    (c) => c.setIsMutedOverride,
  );
  // Focus of the Learn stack in the tab navigator — unaffected by locking the phone.
  const focused = useIsFocused();
  // Opening Learn's map leaves the cards, as switching tabs does: it ends a voice session.
  const isMapOpen = useIsLearnMapOpen();
  return (
    <VoiceStudyProvider focused={focused && !isMapOpen} muted={muted} setMuted={setMuted}>
      <LearnLayoutContext.Provider value={value}>{children}</LearnLayoutContext.Provider>
    </VoiceStudyProvider>
  );
}
